/**
 * @generated SignedSource<<169288e96b43e53fff2601d61653366b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLJobTaskType = "AGENT" | "AGENT_DASHBOARD_SNAPSHOT" | "ALERT_INSIGHTS" | "ALERT_RESPONDER" | "ALERT_THREAD_LEARNING" | "AWS_MARKETPLACE_METERING" | "BITBUCKET_TOKEN_REFRESH" | "BUILDKITE_SYNC" | "CODE_PULL" | "CREDITS_COMPUTATION_V2" | "CTA_REMINDER" | "CUSTOMER_AGENT_IMAGE_BUILD" | "CUSTOMER_AGENT_SANDBOX_IMAGE_CACHE" | "CUSTOM_MCP_SERVER_TOOL_REFRESH" | "DAG_AGENT" | "DATABRICKS_MEMORY_INGESTION" | "DATABRICKS_SYNC" | "DATABRICKS_TO_POSTGRES_SYNC" | "DIGEST" | "GENERIC_LEARNING" | "GITHUB_CODEBASE_ANALYSIS" | "GITLAB_TOKEN_REFRESH" | "GRAFANA_CLOUD_DATASOURCE_SYNC" | "INCIDENT_CHANNEL_LEARNING" | "INCIDENT_DAG_AGENT" | "INCIDENT_KNOWLEDGE_SYNC" | "INGEST_SLACK_CHANNEL" | "NEWRELIC_APPLICATION_SYNC" | "ONBOARDING" | "ONBOARDING_QUESTION_TRAINING" | "PRODUCT_ANALYTICS" | "RESOURCE_FILES_SYNC" | "RESOURCE_SYNC_QUEUE" | "SLACK_CACHE_REFRESH" | "SLACK_USERGROUP_REFRESH" | "SNAPSHOT_CLEANUP" | "SUPPORT_AGENT_METRIC_CALCULATOR" | "SUPPORT_INSTRUCTION_GENERATION" | "TEAM_INSTRUCTION_GENERATION" | "WHAT_TIME_IS_IT_RIGHT_NOW" | "WORKFLOW_INVESTIGATION" | "WORKFLOW_MEMORY_CONSOLIDATION" | "WORKFLOW_MEMORY_EVAL_RECONCILER" | "%future added value";
export type Status = "ACTIVE" | "PAUSED" | "%future added value";
export type CreateJobInput = {
  alertId?: any | null | undefined;
  inputJson?: any | null | undefined;
  name: string;
  notificationIntegrationIds?: ReadonlyArray<any> | null | undefined;
  schedule?: any | null | undefined;
  slackChannelIds?: ReadonlyArray<string> | null | undefined;
  taskType: GraphQLJobTaskType;
  teamId: any;
};
export type CreateJobMutation$variables = {
  input: CreateJobInput;
};
export type CreateJobMutation$data = {
  readonly createJob: {
    readonly job: {
      readonly id: any;
      readonly inputJson: any;
      readonly name: string;
      readonly schedule: any | null | undefined;
      readonly status: Status;
      readonly taskType: GraphQLJobTaskType;
    };
  };
};
export type CreateJobMutation = {
  response: CreateJobMutation$data;
  variables: CreateJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateJobPayload",
    "kind": "LinkedField",
    "name": "createJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJob",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inputJson",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schedule",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateJobMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateJobMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd03b26e23347d68054bb36380dc2a7f",
    "id": null,
    "metadata": {},
    "name": "CreateJobMutation",
    "operationKind": "mutation",
    "text": "mutation CreateJobMutation(\n  $input: CreateJobInput!\n) {\n  createJob(input: $input) {\n    job {\n      id\n      name\n      inputJson\n      schedule\n      taskType\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "afd8a6348deb7442e2d35a7f5c09df58";

export default node;
